export default __webpack_public_path__ + "static/media/paypal-logo.f91ba50c.jpeg";